export enum HOT_KEY {
  CTRL = 'Control',
  SHIFT = 'Shift',
  ENTER = 'Enter',
  TAB = 'Tab',
  ESCAPE = 'Escape',
  ARROW_UP = 'ArrowUp',
  ARROW_DOWN = 'ArrowDown',
  DOT = '.',
}
